import { render, staticRenderFns } from "./foundation.vue?vue&type=template&id=1b9ba84a&scoped=true"
var script = {}
import style0 from "./foundation.vue?vue&type=style&index=0&id=1b9ba84a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ba84a",
  null
  
)

export default component.exports